module.exports = __webpack_public_path__ + "img/uk-aid-logo-transparent.e246cdd1.png";